import { FC, PropsWithChildren } from 'react';

import { Tooltip } from '@mui/joy';
import { Stack } from '@mui/material';

const TOOLTIP_MESSAGE = 'Редагування інформації закритих періодів заборонено';

const sx = {
  '& > button, & > div, & > li, & > a, & > span, & p': {
    pointerEvents: 'none',
    opacity: 0.5,
    cursor: 'not-allowed',
  },
};

export const ModificationDenyTooltip: FC<
  PropsWithChildren<{ tooltip?: string }>
> = ({ children, tooltip }) => (
  <Tooltip
    title={tooltip || TOOLTIP_MESSAGE}
    sx={{
      maxWidth: '250px',
      pointerEvents: 'none',
    }}
  >
    <Stack sx={sx}>{children}</Stack>
  </Tooltip>
);
